// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Vvn3b","openMessanger":"styles_openMessanger__SfsKp","icon":"styles_icon__osNZC","container":"styles_container__joNNp"};